<template>


    <div>
        <!-- choose image or animated avatar-->
        <div class="TQ_grid_col_1fr1fr TQ_text_20px TQ_margin_4px TQ_grid_gap_4px TQ_direction_ltr TQ_text_capitalize">
            <div class="TQ_bg_gray4 TQ_padding_8px TQ_box_shadow TQ_borderRadius_left  TQ_clickable" :class="{'TQ_bg_purple' : p_ud_avatar_c.cuda_avatarImage_b}"
                 @click="p_ud_avatar_c.cuda_avatarImage_b=true">
                {{ ass_strings.oneWord_image[p_system_langCode_e] }}
            </div>
            <div class="TQ_bg_gray4 TQ_padding_8px TQ_box_shadow TQ_borderRadius_right TQ_clickable" :class="{'TQ_bg_purple' : !p_ud_avatar_c.cuda_avatarImage_b}"
                 @click="p_ud_avatar_c.cuda_avatarImage_b=false">
                {{ ass_strings.oneWord_animated[p_system_langCode_e] }}
            </div>
        </div>

        <!-- choose image-->
        <div v-if="p_ud_avatar_c.cuda_avatarImage_b" class="TQ_center TQ_padding_8px">
            <tq-select-image
                :p_get-image-file_vf="pp_getFile_vf"
                p_file-name_s="userImage"
                :p_initial-image_s="p_ud_avatar_c.cuda_imgFile_c.fi_url_s"
                :p_index_n="0"
                :width="200"
                :height="200"/>
        </div>

        <!-- animated avatar -->
        <div v-else class="TQ_grid_col_Auto1frAuto">

            <!-- tabs -->
            <div class="TQ_width_125px TQ_borderBox TQ_margin_1px TQ_padding_4px TQ_borderRadius TQ_bg_gray4 TQ_text_capitalize">
                <div v-for="tabs_o in co_tabs_ao" @click="selectedTabIndex_n = tabs_o.id"
                     :class="{'TQ_bg_purple' : selectedTabIndex_n === tabs_o.id}"
                     class="TQ_padding_8px TQ_inline TQ_bg_white TQ_margin_bottom_4px TQ_clickable TQ_width_100p TQ_borderBox TQ_box_shadow TQ_borderRadius">
                    {{tabs_o.title}}
                </div>
            </div>

            <!-- avatar and options-->
            <div class="TQ_margin_1px">

                <!-- avatar -->
                <div class="TQ_bg_gray4 TQ_margin_bottom_4px TQ_padding_8px TQ_borderRadius">

                    <div class="TQ_center TQ_inline">
                        <tq-on-top-container class="TQ_margin_top_8px">
                            <tq-image slot="topRight" @click.native="m_random_f" :pb_src_r="ass_img_dices_b"
                                      class="TQ_clickable lc_randomDices TQ_width_24px TQ_bg_gold TQ_box_shadow2 TQ_borderRadius TQ_padding_4px"/>

                            <tq-avatar key="test2" slot="body" :p_ud_avatar_c="p_ud_avatar_c" class="TQ_verticalAlignMiddle TQ_width_100p TQ_maxWidth_150px TQ_borderRadius  TQ_borderBox TQ_box_shadow TQ_bg_white "></tq-avatar>
                        </tq-on-top-container>
                    </div>




                </div>

                <!-- options -->
                <div class="TQ_maxHeight_300px TQ_scrollable TQ_bg_gray4 TQ_padding_8px TQ_borderRadius">

                    <!-- top -->
                    <div v-if="selectedTabIndex_n===0">

                        <!-- choose color -->
                        <tq-pick-color :p_system-lang-code_e="p_system_langCode_e"
                                       :pe_change-color_s="(newColor_s) => {p_ud_avatar_c.cuda_hairColor_s=newColor_s}"
                                       class="TQ_inline TQ_verticalAlignTop"
                                       :p_init-color_s="p_ud_avatar_c.cuda_hairColor_s">
                            <div class="TQ_padding_2px TQ_width_80px TQ_height_80px TQ_inline TQ_margin_2px   TQ_clickable TQ_box_shadow TQ_borderRadius " :style="{background: p_ud_avatar_c.cuda_hairColor_s}" >

                            </div>
                        </tq-pick-color>


                        <div @click="p_ud_avatar_c.cuda_top_e = avatar_top"
                             :title="avatar_top"
                             class="TQ_inline TQ_padding_2px TQ_bg_white TQ_margin_2px TQ_clickable TQ_borderRadius TQ_box_shadow"
                             :class="{'TQ_bg_gold' : p_ud_avatar_c.cuda_top_e === avatar_top}"
                             v-for="avatar_top in enum_avatar_topOptions_e">

                            <svg width="80px" height="80px" viewBox="0 0 264 264" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <g id="Body" transform="translate(32.000000, 36.000000)">
                                    <defs>
                                        <circle id="react-path-1" cx="120" cy="120" r="120"/>
                                        <path d="M12,160 C12,226.27417 65.72583,280 132,280 C198.27417,280 252,226.27417 252,160 L264,160 L264,-1.42108547e-14 L-3.19744231e-14,-1.42108547e-14 L-3.19744231e-14,160 L12,160 Z" id="react-path-2"/>
                                        <path d="M124,144.610951 L124,163 L128,163 L128,163 C167.764502,163 200,195.235498 200,235 L200,244 L0,244 L0,235 C-4.86974701e-15,195.235498 32.235498,163 72,163 L72,163 L76,163 L76,144.610951 C58.7626345,136.422372 46.3722246,119.687011 44.3051388,99.8812385 C38.4803105,99.0577866 34,94.0521096 34,88 L34,74 C34,68.0540074 38.3245733,63.1180731 44,62.1659169 L44,56 L44,56 C44,25.072054 69.072054,5.68137151e-15 100,0 L100,0 L100,0 C130.927946,-5.68137151e-15 156,25.072054 156,56 L156,62.1659169 C161.675427,63.1180731 166,68.0540074 166,74 L166,88 C166,94.0521096 161.51969,99.0577866 155.694861,99.8812385 C153.627775,119.687011 141.237365,136.422372 124,144.610951 Z" id="react-path-3"/>
                                    </defs>

                                    <mask id="react-mask-6" fill="white">
                                        <use xlink:href="#react-path-3"/>
                                    </mask>
                                    <use fill="#D0C6AC" xlink:href="#react-path-3"/>
                                    <g id="Skin/👶🏽-03-Brown" mask="url(#react-mask-6)" fill="#FFDBB4">
                                        <g transform="translate(0.000000, 0.000000)" id="Color">
                                            <rect x="0" y="0" width="264" height="280"/>
                                        </g>
                                    </g>
                                    <path d="M156,79 L156,102 C156,132.927946 130.927946,158 100,158 C69.072054,158 44,132.927946 44,102 L44,79 L44,94 C44,124.927946 69.072054,150 100,150 C130.927946,150 156,124.927946 156,94 L156,79 Z" id="Neck-Shadow" fill-opacity="0.100000001" fill="#000000" mask="url(#react-mask-6)"/>
                                </g>

                                <g v-html="avatar_top_xml(avatar_top, p_ud_avatar_c.cuda_hairColor_s)"></g>
                            </svg>
                        </div>
                    </div>

                    <!-- accessories -->
                    <div v-if="selectedTabIndex_n===1">
                        <div @click="p_ud_avatar_c.cuda_accessories_e = accessories_e"
                             class="TQ_inline TQ_padding_2px TQ_bg_white TQ_margin_2px TQ_clickable TQ_borderRadius TQ_box_shadow"
                             :class="{'TQ_bg_gold' : p_ud_avatar_c.cuda_accessories_e === accessories_e}"

                             v-for="accessories_e in enum_avatar_top_accessories_e">

                            <svg width="80px" height="80px" viewBox="0 0 264 264" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <g id="Body" transform="translate(32.000000, 36.000000)">
                                    <defs>
                                        <circle id="react-path-1" cx="120" cy="120" r="120"/>
                                        <path d="M12,160 C12,226.27417 65.72583,280 132,280 C198.27417,280 252,226.27417 252,160 L264,160 L264,-1.42108547e-14 L-3.19744231e-14,-1.42108547e-14 L-3.19744231e-14,160 L12,160 Z" id="react-path-2"/>
                                        <path d="M124,144.610951 L124,163 L128,163 L128,163 C167.764502,163 200,195.235498 200,235 L200,244 L0,244 L0,235 C-4.86974701e-15,195.235498 32.235498,163 72,163 L72,163 L76,163 L76,144.610951 C58.7626345,136.422372 46.3722246,119.687011 44.3051388,99.8812385 C38.4803105,99.0577866 34,94.0521096 34,88 L34,74 C34,68.0540074 38.3245733,63.1180731 44,62.1659169 L44,56 L44,56 C44,25.072054 69.072054,5.68137151e-15 100,0 L100,0 L100,0 C130.927946,-5.68137151e-15 156,25.072054 156,56 L156,62.1659169 C161.675427,63.1180731 166,68.0540074 166,74 L166,88 C166,94.0521096 161.51969,99.0577866 155.694861,99.8812385 C153.627775,119.687011 141.237365,136.422372 124,144.610951 Z" id="react-path-3"/>
                                    </defs>

                                    <mask id="react-mask-6" fill="white">
                                        <use xlink:href="#react-path-3"/>
                                    </mask>
                                    <use fill="#D0C6AC" xlink:href="#react-path-3"/>
                                    <g id="Skin/👶🏽-03-Brown" mask="url(#react-mask-6)" fill="#FFDBB4">
                                        <g transform="translate(0.000000, 0.000000)" id="Color">
                                            <rect x="0" y="0" width="264" height="280"/>
                                        </g>
                                    </g>
                                    <path d="M156,79 L156,102 C156,132.927946 130.927946,158 100,158 C69.072054,158 44,132.927946 44,102 L44,79 L44,94 C44,124.927946 69.072054,150 100,150 C130.927946,150 156,124.927946 156,94 L156,79 Z" id="Neck-Shadow" fill-opacity="0.100000001" fill="#000000" mask="url(#react-mask-6)"/>
                                </g>

                                <g v-html="avatar_accessories_xml(accessories_e)"></g>
                            </svg>
                        </div>
                    </div>

                    <!-- facialHair -->
                    <div v-if="selectedTabIndex_n===2">

                        <!-- choose color -->
                        <tq-pick-color :p_system-lang-code_e="p_system_langCode_e"
                                       :pe_change-color_s="(newColor_s) => {p_ud_avatar_c.cuda_hairColor_s=newColor_s}"
                                       class="TQ_inline TQ_verticalAlignTop"
                                       :p_init-color_s="p_ud_avatar_c.cuda_hairColor_s">
                            <div class="TQ_padding_2px TQ_width_80px TQ_height_80px TQ_inline TQ_margin_2px   TQ_clickable TQ_box_shadow TQ_borderRadius " :style="{background: p_ud_avatar_c.cuda_hairColor_s}" >

                            </div>
                        </tq-pick-color>


                        <div @click="p_ud_avatar_c.cuda_facialHair_e = avatar_top_facialHair_e"
                             class="TQ_inline TQ_padding_2px TQ_bg_white TQ_margin_2px TQ_clickable TQ_borderRadius TQ_box_shadow"
                             :class="{'TQ_bg_gold' : p_ud_avatar_c.cuda_facialHair_e === avatar_top_facialHair_e}"

                             v-for="avatar_top_facialHair_e in enum_avatar_top_facialHair_e">

                            <svg width="80px" height="80px" viewBox="0 0 264 264" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <g id="Body" transform="translate(32.000000, 36.000000)">
                                    <defs>
                                        <circle id="react-path-1" cx="120" cy="120" r="120"/>
                                        <path d="M12,160 C12,226.27417 65.72583,280 132,280 C198.27417,280 252,226.27417 252,160 L264,160 L264,-1.42108547e-14 L-3.19744231e-14,-1.42108547e-14 L-3.19744231e-14,160 L12,160 Z" id="react-path-2"/>
                                        <path d="M124,144.610951 L124,163 L128,163 L128,163 C167.764502,163 200,195.235498 200,235 L200,244 L0,244 L0,235 C-4.86974701e-15,195.235498 32.235498,163 72,163 L72,163 L76,163 L76,144.610951 C58.7626345,136.422372 46.3722246,119.687011 44.3051388,99.8812385 C38.4803105,99.0577866 34,94.0521096 34,88 L34,74 C34,68.0540074 38.3245733,63.1180731 44,62.1659169 L44,56 L44,56 C44,25.072054 69.072054,5.68137151e-15 100,0 L100,0 L100,0 C130.927946,-5.68137151e-15 156,25.072054 156,56 L156,62.1659169 C161.675427,63.1180731 166,68.0540074 166,74 L166,88 C166,94.0521096 161.51969,99.0577866 155.694861,99.8812385 C153.627775,119.687011 141.237365,136.422372 124,144.610951 Z" id="react-path-3"/>
                                    </defs>

                                    <mask id="react-mask-6" fill="white">
                                        <use xlink:href="#react-path-3"/>
                                    </mask>
                                    <use fill="#D0C6AC" xlink:href="#react-path-3"/>
                                    <g id="Skin/👶🏽-03-Brown" mask="url(#react-mask-6)" fill="#FFDBB4">
                                        <g transform="translate(0.000000, 0.000000)" id="Color">
                                            <rect x="0" y="0" width="264" height="280"/>
                                        </g>
                                    </g>
                                    <path d="M156,79 L156,102 C156,132.927946 130.927946,158 100,158 C69.072054,158 44,132.927946 44,102 L44,79 L44,94 C44,124.927946 69.072054,150 100,150 C130.927946,150 156,124.927946 156,94 L156,79 Z" id="Neck-Shadow" fill-opacity="0.100000001" fill="#000000" mask="url(#react-mask-6)"/>
                                </g>
                                <g v-html="avatar_facialHair_xml(avatar_top_facialHair_e, p_ud_avatar_c.cuda_hairColor_s)"></g>
                            </svg>
                        </div>
                    </div>

                    <!-- eyebrow -->
                    <div v-if="selectedTabIndex_n===3">
                        <div @click="p_ud_avatar_c.cuda_eyebrow_e = eyebrow_e"
                             class="TQ_inline TQ_padding_2px TQ_bg_white TQ_margin_2px TQ_clickable TQ_borderRadius TQ_box_shadow"
                             :class="{'TQ_bg_gold' : p_ud_avatar_c.cuda_eyebrow_e === eyebrow_e}"
                             v-for="eyebrow_e in enum_avatar_eyebrow_e">

                            <svg width="80px" height="80px" viewBox="0 0 264 264" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <g id="Body" transform="translate(32.000000, 36.000000)">
                                    <defs>
                                        <circle id="react-path-1" cx="120" cy="120" r="120"/>
                                        <path d="M12,160 C12,226.27417 65.72583,280 132,280 C198.27417,280 252,226.27417 252,160 L264,160 L264,-1.42108547e-14 L-3.19744231e-14,-1.42108547e-14 L-3.19744231e-14,160 L12,160 Z" id="react-path-2"/>
                                        <path d="M124,144.610951 L124,163 L128,163 L128,163 C167.764502,163 200,195.235498 200,235 L200,244 L0,244 L0,235 C-4.86974701e-15,195.235498 32.235498,163 72,163 L72,163 L76,163 L76,144.610951 C58.7626345,136.422372 46.3722246,119.687011 44.3051388,99.8812385 C38.4803105,99.0577866 34,94.0521096 34,88 L34,74 C34,68.0540074 38.3245733,63.1180731 44,62.1659169 L44,56 L44,56 C44,25.072054 69.072054,5.68137151e-15 100,0 L100,0 L100,0 C130.927946,-5.68137151e-15 156,25.072054 156,56 L156,62.1659169 C161.675427,63.1180731 166,68.0540074 166,74 L166,88 C166,94.0521096 161.51969,99.0577866 155.694861,99.8812385 C153.627775,119.687011 141.237365,136.422372 124,144.610951 Z" id="react-path-3"/>
                                    </defs>

                                    <mask id="react-mask-6" fill="white">
                                        <use xlink:href="#react-path-3"/>
                                    </mask>
                                    <use fill="#D0C6AC" xlink:href="#react-path-3"/>
                                    <g id="Skin/👶🏽-03-Brown" mask="url(#react-mask-6)" fill="#FFDBB4">
                                        <g transform="translate(0.000000, 0.000000)" id="Color">
                                            <rect x="0" y="0" width="264" height="280"/>
                                        </g>
                                    </g>
                                    <path d="M156,79 L156,102 C156,132.927946 130.927946,158 100,158 C69.072054,158 44,132.927946 44,102 L44,79 L44,94 C44,124.927946 69.072054,150 100,150 C130.927946,150 156,124.927946 156,94 L156,79 Z" id="Neck-Shadow" fill-opacity="0.100000001" fill="#000000" mask="url(#react-mask-6)"/>
                                </g>
                                <g id="Face" transform="translate(76.000000, 82.000000)" fill="#000000">
                                    <g v-html="avatar_eyebrow_xml(eyebrow_e)"></g>
                                </g>
                            </svg>
                        </div>
                    </div>

                    <!-- mouth -->
                    <div v-if="selectedTabIndex_n===4">
                        <div @click="p_ud_avatar_c.cuda_mouth_e = avatar_mouth_e"
                             class="TQ_inline TQ_padding_2px TQ_bg_white TQ_margin_2px TQ_clickable TQ_borderRadius TQ_box_shadow"
                             :class="{'TQ_bg_gold' : p_ud_avatar_c.cuda_mouth_e === avatar_mouth_e}"
                             v-for="avatar_mouth_e in enum_avatar_mouth_e">

                            <svg width="80px" height="80px" viewBox="0 0 264 264" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <g id="Body" transform="translate(32.000000, 36.000000)">
                                    <defs>
                                        <circle id="react-path-1" cx="120" cy="120" r="120"/>
                                        <path d="M12,160 C12,226.27417 65.72583,280 132,280 C198.27417,280 252,226.27417 252,160 L264,160 L264,-1.42108547e-14 L-3.19744231e-14,-1.42108547e-14 L-3.19744231e-14,160 L12,160 Z" id="react-path-2"/>
                                        <path d="M124,144.610951 L124,163 L128,163 L128,163 C167.764502,163 200,195.235498 200,235 L200,244 L0,244 L0,235 C-4.86974701e-15,195.235498 32.235498,163 72,163 L72,163 L76,163 L76,144.610951 C58.7626345,136.422372 46.3722246,119.687011 44.3051388,99.8812385 C38.4803105,99.0577866 34,94.0521096 34,88 L34,74 C34,68.0540074 38.3245733,63.1180731 44,62.1659169 L44,56 L44,56 C44,25.072054 69.072054,5.68137151e-15 100,0 L100,0 L100,0 C130.927946,-5.68137151e-15 156,25.072054 156,56 L156,62.1659169 C161.675427,63.1180731 166,68.0540074 166,74 L166,88 C166,94.0521096 161.51969,99.0577866 155.694861,99.8812385 C153.627775,119.687011 141.237365,136.422372 124,144.610951 Z" id="react-path-3"/>
                                    </defs>

                                    <mask id="react-mask-6" fill="white">
                                        <use xlink:href="#react-path-3"/>
                                    </mask>
                                    <use fill="#D0C6AC" xlink:href="#react-path-3"/>
                                    <g id="Skin/👶🏽-03-Brown" mask="url(#react-mask-6)" fill="#FFDBB4">
                                        <g transform="translate(0.000000, 0.000000)" id="Color">
                                            <rect x="0" y="0" width="264" height="280"/>
                                        </g>
                                    </g>
                                    <path d="M156,79 L156,102 C156,132.927946 130.927946,158 100,158 C69.072054,158 44,132.927946 44,102 L44,79 L44,94 C44,124.927946 69.072054,150 100,150 C130.927946,150 156,124.927946 156,94 L156,79 Z" id="Neck-Shadow" fill-opacity="0.100000001" fill="#000000" mask="url(#react-mask-6)"/>
                                </g>
                                <g id="Face" transform="translate(76.000000, 82.000000)" fill="#000000">
                                    <g v-html="avatar_mouth_xml(avatar_mouth_e)"></g>
                                </g>
                            </svg>
                        </div>
                    </div>

                    <!-- eyes -->
                    <div v-if="selectedTabIndex_n===5">
                        <div @click="p_ud_avatar_c.cuda_eyes_e = eyes_e"
                             class="TQ_inline TQ_padding_2px TQ_bg_white TQ_margin_2px TQ_clickable TQ_borderRadius TQ_box_shadow"
                             :class="{'TQ_bg_gold' : p_ud_avatar_c.cuda_eyes_e === eyes_e}"
                             v-for="eyes_e in enum_avatar_eyes_e">

                            <svg width="80px" height="80px" viewBox="0 0 264 264" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <g id="Body" transform="translate(32.000000, 36.000000)">
                                    <defs>
                                        <circle id="react-path-1" cx="120" cy="120" r="120"/>
                                        <path d="M12,160 C12,226.27417 65.72583,280 132,280 C198.27417,280 252,226.27417 252,160 L264,160 L264,-1.42108547e-14 L-3.19744231e-14,-1.42108547e-14 L-3.19744231e-14,160 L12,160 Z" id="react-path-2"/>
                                        <path d="M124,144.610951 L124,163 L128,163 L128,163 C167.764502,163 200,195.235498 200,235 L200,244 L0,244 L0,235 C-4.86974701e-15,195.235498 32.235498,163 72,163 L72,163 L76,163 L76,144.610951 C58.7626345,136.422372 46.3722246,119.687011 44.3051388,99.8812385 C38.4803105,99.0577866 34,94.0521096 34,88 L34,74 C34,68.0540074 38.3245733,63.1180731 44,62.1659169 L44,56 L44,56 C44,25.072054 69.072054,5.68137151e-15 100,0 L100,0 L100,0 C130.927946,-5.68137151e-15 156,25.072054 156,56 L156,62.1659169 C161.675427,63.1180731 166,68.0540074 166,74 L166,88 C166,94.0521096 161.51969,99.0577866 155.694861,99.8812385 C153.627775,119.687011 141.237365,136.422372 124,144.610951 Z" id="react-path-3"/>
                                    </defs>

                                    <mask id="react-mask-6" fill="white">
                                        <use xlink:href="#react-path-3"/>
                                    </mask>
                                    <use fill="#D0C6AC" xlink:href="#react-path-3"/>
                                    <g id="Skin/👶🏽-03-Brown" mask="url(#react-mask-6)" fill="#FFDBB4">
                                        <g transform="translate(0.000000, 0.000000)" id="Color">
                                            <rect x="0" y="0" width="264" height="280"/>
                                        </g>
                                    </g>
                                    <path d="M156,79 L156,102 C156,132.927946 130.927946,158 100,158 C69.072054,158 44,132.927946 44,102 L44,79 L44,94 C44,124.927946 69.072054,150 100,150 C130.927946,150 156,124.927946 156,94 L156,79 Z" id="Neck-Shadow" fill-opacity="0.100000001" fill="#000000" mask="url(#react-mask-6)"/>
                                </g>
                                <g id="Face" transform="translate(76.000000, 82.000000)" fill="#000000">
                                    <g v-html="avatar_eyes_xml(eyes_e)"></g>
                                </g>
                            </svg>
                        </div>
                    </div>

                    <!-- clothing -->
                    <div v-if="selectedTabIndex_n===6">

                        <!-- choose color -->
                        <tq-pick-color :p_system-lang-code_e="p_system_langCode_e"
                                       :pe_change-color_s="(newColor_s) => {p_ud_avatar_c.cuda_clothingColor_s=newColor_s}"
                                       class="TQ_inline TQ_verticalAlignTop"
                                       :p_init-color_s="p_ud_avatar_c.cuda_clothingColor_s">
                            <div class="TQ_padding_2px TQ_width_80px TQ_height_80px TQ_inline TQ_margin_2px   TQ_clickable TQ_box_shadow TQ_borderRadius " :style="{background: p_ud_avatar_c.cuda_clothingColor_s}" >

                            </div>
                        </tq-pick-color>

                        <!-- options -->
                        <div @click="p_ud_avatar_c.cuda_clothing_e = avatar_clothing"
                             class="TQ_inline TQ_padding_2px TQ_bg_white TQ_margin_2px TQ_clickable TQ_borderRadius TQ_box_shadow TQ_verticalAlignTop"
                             :class="{'TQ_bg_gold' : p_ud_avatar_c.cuda_clothing_e === avatar_clothing}"
                             :title="avatar_clothing"
                             v-for="avatar_clothing in enum_avatar_clothing_e">

                            <svg width="80px" height="80px" viewBox="0 0 280 280" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <g transform="translate(12, 0)">
                                    <g id="Body" transform="translate(32.000000, 36.000000)">
                                        <defs>
                                            <circle id="react-path-1" cx="120" cy="120" r="120"/>
                                            <path d="M12,160 C12,226.27417 65.72583,280 132,280 C198.27417,280 252,226.27417 252,160 L264,160 L264,-1.42108547e-14 L-3.19744231e-14,-1.42108547e-14 L-3.19744231e-14,160 L12,160 Z" id="react-path-2"/>
                                            <path d="M124,144.610951 L124,163 L128,163 L128,163 C167.764502,163 200,195.235498 200,235 L200,244 L0,244 L0,235 C-4.86974701e-15,195.235498 32.235498,163 72,163 L72,163 L76,163 L76,144.610951 C58.7626345,136.422372 46.3722246,119.687011 44.3051388,99.8812385 C38.4803105,99.0577866 34,94.0521096 34,88 L34,74 C34,68.0540074 38.3245733,63.1180731 44,62.1659169 L44,56 L44,56 C44,25.072054 69.072054,5.68137151e-15 100,0 L100,0 L100,0 C130.927946,-5.68137151e-15 156,25.072054 156,56 L156,62.1659169 C161.675427,63.1180731 166,68.0540074 166,74 L166,88 C166,94.0521096 161.51969,99.0577866 155.694861,99.8812385 C153.627775,119.687011 141.237365,136.422372 124,144.610951 Z" id="react-path-3"/>
                                        </defs>

                                        <mask id="react-mask-6" fill="white">
                                            <use xlink:href="#react-path-3"/>
                                        </mask>
                                        <use fill="#D0C6AC" xlink:href="#react-path-3"/>
                                        <g id="Skin/👶🏽-03-Brown" mask="url(#react-mask-6)" fill="#FFDBB4">
                                            <g transform="translate(0.000000, 0.000000)" id="Color">
                                                <rect x="0" y="0" width="264" height="280"/>
                                            </g>
                                        </g>
                                        <path d="M156,79 L156,102 C156,132.927946 130.927946,158 100,158 C69.072054,158 44,132.927946 44,102 L44,79 L44,94 C44,124.927946 69.072054,150 100,150 C130.927946,150 156,124.927946 156,94 L156,79 Z" id="Neck-Shadow" fill-opacity="0.100000001" fill="#000000" mask="url(#react-mask-6)"/>
                                    </g>

                                    <g v-html="avatar_clothing_xml(avatar_clothing, p_ud_avatar_c.cuda_clothingColor_s)"></g>

                                </g>


                            </svg>
                        </div>

                    </div>

                </div>
            </div>

        </div>



    </div>



</template>

<script>
import TqAvatar from "@/components/complex/TqAvatar";
import {
    enum_avatar_clothing_e, enum_avatar_eyebrow_e,
    enum_avatar_eyes_e, enum_avatar_mouth_e, enum_avatar_top_accessories_e,
    enum_avatar_top_e, enum_avatar_top_facialHair_e, enum_langCodes
} from "../../../functions/src/shareCode/Share_S_Enum";
import TqDropdown from "@/components/basic/TqDropdown";
import {FB_UserData_Avatar} from "../../../functions/src/shareCode/Share_S_Classes";
import {
    avatar_accessories_xml, avatar_clothing_xml,
    avatar_eyebrow_xml, avatar_eyes_xml, avatar_mouth_xml,
    avatar_facialHair_xml,
    avatar_top_xml
} from "@/scripts/S_Avatar";
import TqTabs from "@/components/basic/TqTabs";
import {validator_enum_fb, validator_objEmpty_fb} from "../../../functions/src/shareCode/Share_S_Validator";
import TqPickColor from "@/components/basic2/TqPickColor";
import TqSelectImage from "@/components/mediaComponenets/TqSelectImage";
import {ass_img_dices_b} from "@/assets/scripts/Ass_Files";
import TqImage from "@/components/basic/TqImage";
import TqOnTopContainer from "@/components/basic/TqOnTopContainer";
import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
export default {
    name: "FccAvatarGenerator",
    components: {TqOnTopContainer, TqImage, TqSelectImage, TqPickColor, TqTabs, TqDropdown, TqAvatar},
    props:{
        p_ud_avatar_c:{
            type: FB_UserData_Avatar,
            require: true,
        },
        pp_getFile_vf:{},
        p_system_langCode_e:{
            type: String,
            require: true,
            validator(langCode){
                return validator_enum_fb(enum_langCodes, langCode)
            }
        },

    },
    data(){
        return {

            selectedTabIndex_n:  0,
            avatar_top_s : enum_avatar_top_e.NoHair,
            avatar_clothing_s : enum_avatar_clothing_e.BlazerShirt,
            avatar_eyes_s : enum_avatar_eyes_e.Default,
            avatar_mouth_s : enum_avatar_mouth_e.Default,

            // imports
            avatar_accessories_xml  : avatar_accessories_xml,
            avatar_top_xml          : avatar_top_xml,
            avatar_facialHair_xml   : avatar_facialHair_xml,
            avatar_eyebrow_xml      : avatar_eyebrow_xml,
            avatar_mouth_xml        : avatar_mouth_xml,
            avatar_eyes_xml         : avatar_eyes_xml,
            avatar_clothing_xml     : avatar_clothing_xml,

            ass_img_dices_b        : ass_img_dices_b,
            ass_strings            : ass_strings,

            enum_avatar_topOptions_e   : enum_avatar_top_e,
            enum_avatar_clothing_e   : enum_avatar_clothing_e,
            enum_avatar_eyes_e   : enum_avatar_eyes_e,
            enum_avatar_mouth_e   : enum_avatar_mouth_e,
            enum_avatar_eyebrow_e   : enum_avatar_eyebrow_e,
            enum_avatar_top_facialHair_e   : enum_avatar_top_facialHair_e,
            enum_avatar_top_accessories_e   : enum_avatar_top_accessories_e,
        }
    },
    computed:{
        co_tabs_ao(){

            return [
                {id : 0, title: ass_strings.oneWord_top[this.p_system_langCode_e]},
                {id : 3, title: ass_strings.oneWord_eyebrow[this.p_system_langCode_e]},
                {id : 5, title: ass_strings.oneWord_eyes[this.p_system_langCode_e]},
                {id : 4, title: ass_strings.oneWord_mouth[this.p_system_langCode_e]},
                {id : 2, title: ass_strings.twoWords_facialHair[this.p_system_langCode_e]},
                {id : 6, title: ass_strings.oneWord_clothing[this.p_system_langCode_e]},
                {id : 1, title: ass_strings.oneWord_accessories[this.p_system_langCode_e],},

            ]
        },
    },
    methods:{
        m_random_f(){
            this.p_ud_avatar_c.uda_m_random_f()
        }
    },
}
</script>

<style scoped>
    .lc_randomDices{
        margin-top: -16px;
        margin-right: -16px;
    }
</style>